export default __webpack_public_path__ + "static/media/rector.beb72a4b.jpg";